import { render, staticRenderFns } from "./CamposIntegracao.vue?vue&type=template&id=c52f349c&scoped=true"
import script from "./CamposIntegracao.vue?vue&type=script&lang=js"
export * from "./CamposIntegracao.vue?vue&type=script&lang=js"
import style0 from "./CamposIntegracao.vue?vue&type=style&index=0&id=c52f349c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52f349c",
  null
  
)

export default component.exports